import { workbenchServiceDict } from '@/dictionary/system'
import { bidInviteWayDict } from '@/dictionary/project/bid'

export default {
  // 不同身份展示不同的招标方式
  bidMethodOptions(state) {
    const features = state?.company?.permissionInfo?.features
      ? JSON.parse(state?.company?.permissionInfo?.features)
      : []
    console.log('当前的features：', features)

    if (
      state?.router?.currentWorkbench === workbenchServiceDict.PURCHASER.value &&
      state?.company?.isPurchaser
    ) {
      return (
        features.find(item => item.code === 'funcList')?.value || [
          bidInviteWayDict.PUBLIC_BIDDING.value,
          bidInviteWayDict.INVITE_BIDDING.value,
          bidInviteWayDict.SINGLE_SOURCE.value
        ]
      )
    }
    if (
      state?.router?.currentWorkbench === workbenchServiceDict.AGENCY.value &&
      state?.company?.isAgency
    ) {
      return (
        features.find(item => item.code === 'agencyFuncList')?.value ||
        bidInviteWayDict.array.map(dict => dict.value)
      )
    }
  }
}
